<template funtional lang="pug">
  include ../mixins
  +b.loader-wrapper
    +e.bg(:class="[{ 'loader-wrapper__bg--white': isWhite }, loaderColor]")
    +b.loader(:class="loaderClass")
      +b.preloader(:class="{ 'preloader--color_dark': isWhite }")
        +e.item.let1 l
        +e.item.let2 o
        +e.item.let3 a
        +e.item.let4 d
        +e.item.let5 i
        +e.item.let6 n
        +e.item.let7 g

</template>

<script>
export default {
  name: 'ui-preloader',
  props: {
    isWhite: Boolean,
    loaderColor: String,
    loaderClass: String,
  },
}
</script>
